import "dayjs";
import { r as redirect } from "../../../chunks/index.js";
import { P as PUBLIC_AUTH_ENDPOINT } from "../../../chunks/public.js";
import { decodeJwt } from "jose";
const load = async (event) => {
  if (!event.locals.user) {
    const to = event.request.url.includes("/logout") ? event.url.origin : event.request.url;
    throw redirect(302, PUBLIC_AUTH_ENDPOINT + `?redirect=${to}`);
  }
  return {
    user_info: event.locals.user,
    claim: event.cookies.get("accessToken") ? decodeJwt(event.cookies.get("accessToken")) : null
    // projects: get_projects(event) // move this to (projects_required)/
  };
};
export {
  load
};
//# sourceMappingURL=_layout.server.ts.js.map
